/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Notsubscribedtitle2Inputs */

const id_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak Berlangganan`)
};

const ms_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak Dilanggan`)
};

const da_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke Abonneret`)
};

const de_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht abonniert`)
};

const en_us2_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not Subscribed`)
};

const es_es2_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No suscrito`)
};

const es_mx2_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No suscrito`)
};

const fil_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi Naka-subscribe`)
};

const fr_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non abonné`)
};

const it_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non iscritto`)
};

const hu_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs feliratkozva`)
};

const nl_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet geabonneerd`)
};

const no_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikke abonnert`)
};

const pl_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie subskrybowany`)
};

const pt_br2_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não inscrito`)
};

const pt_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não subscrito`)
};

const ro_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neabonat`)
};

const fi_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei tilattu`)
};

const sv_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inte prenumererad`)
};

const vi_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa đăng ký`)
};

const tr_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abone Değil`)
};

const cs_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepřihlášeno`)
};

const bg_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не е абониран`)
};

const ru_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не подписан`)
};

const uk_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не підписано`)
};

const ar_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غير مشترك`)
};

const hi_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सब्सक्राइब नहीं`)
};

const th_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่ได้สมัครรับ`)
};

const ja_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未購読`)
};

const zh_cn2_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未订阅`)
};

const zh_hant1_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未訂閱`)
};

const ko_notifications_notsubscribedtitle2 = /** @type {(inputs: Notifications_Notsubscribedtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독되지 않음`)
};

/**
* | output |
* | --- |
* | "Not Subscribed" |
*
* @param {Notifications_Notsubscribedtitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_notsubscribedtitle2 = /** @type {((inputs?: Notifications_Notsubscribedtitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Notsubscribedtitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_notsubscribedtitle2(inputs)
	if (locale === "ms") return ms_notifications_notsubscribedtitle2(inputs)
	if (locale === "da") return da_notifications_notsubscribedtitle2(inputs)
	if (locale === "de") return de_notifications_notsubscribedtitle2(inputs)
	if (locale === "en-US") return en_us2_notifications_notsubscribedtitle2(inputs)
	if (locale === "es-ES") return es_es2_notifications_notsubscribedtitle2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_notsubscribedtitle2(inputs)
	if (locale === "fil") return fil_notifications_notsubscribedtitle2(inputs)
	if (locale === "fr") return fr_notifications_notsubscribedtitle2(inputs)
	if (locale === "it") return it_notifications_notsubscribedtitle2(inputs)
	if (locale === "hu") return hu_notifications_notsubscribedtitle2(inputs)
	if (locale === "nl") return nl_notifications_notsubscribedtitle2(inputs)
	if (locale === "no") return no_notifications_notsubscribedtitle2(inputs)
	if (locale === "pl") return pl_notifications_notsubscribedtitle2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_notsubscribedtitle2(inputs)
	if (locale === "pt") return pt_notifications_notsubscribedtitle2(inputs)
	if (locale === "ro") return ro_notifications_notsubscribedtitle2(inputs)
	if (locale === "fi") return fi_notifications_notsubscribedtitle2(inputs)
	if (locale === "sv") return sv_notifications_notsubscribedtitle2(inputs)
	if (locale === "vi") return vi_notifications_notsubscribedtitle2(inputs)
	if (locale === "tr") return tr_notifications_notsubscribedtitle2(inputs)
	if (locale === "cs") return cs_notifications_notsubscribedtitle2(inputs)
	if (locale === "bg") return bg_notifications_notsubscribedtitle2(inputs)
	if (locale === "ru") return ru_notifications_notsubscribedtitle2(inputs)
	if (locale === "uk") return uk_notifications_notsubscribedtitle2(inputs)
	if (locale === "ar") return ar_notifications_notsubscribedtitle2(inputs)
	if (locale === "hi") return hi_notifications_notsubscribedtitle2(inputs)
	if (locale === "th") return th_notifications_notsubscribedtitle2(inputs)
	if (locale === "ja") return ja_notifications_notsubscribedtitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_notsubscribedtitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_notsubscribedtitle2(inputs)
	return ko_notifications_notsubscribedtitle2(inputs)
});
export { notifications_notsubscribedtitle2 as "notifications.notSubscribedTitle" }